<div class="ui-field" [style.width.px]="widthPx ?? null">
  <label *ngIf="label" class="ui-label">
    {{ label }} <span *ngIf="isRequired" class="req">*</span>
  </label>

  <div
    class="input-control"
    [ngClass]="{
      'input-control--sm': size === 'sm',
      'input-control--lg': size === 'lg',
      'input-control--disabled': disabled,
    }"
  >
    <div class="input-control__wrap">
      <ng-content select="[prefix]"></ng-content>

      <input
        class="input-control__field"
        [type]="inputType"
        [value]="value"
        [placeholder]="placeholder"
        [disabled]="disabled"
        [readOnly]="readonly"
        (input)="updateValue($any($event.target).value)"
        (blur)="markTouched()"
      />

      <div
        *ngIf="type === 'password' && showTogglePassword"
        class="input-control__suffix-btn"
        (click)="togglePassword()"
        aria-label="แสดง/ซ่อน"
      >
        <mat-icon class="suffix-icon">
          {{ hidePassword ? "visibility" : "visibility_off" }}
        </mat-icon>
      </div>

      <div
        *ngIf="showCopy"
        class="input-control__suffix-btn"
        (click)="copyValue()"
        aria-label="คัดลอก"
      >
        <mat-icon class="suffix-icon">
          {{ copied ? "check" : "content_copy" }}
        </mat-icon>
      </div>

      <ng-content select="[suffix]"></ng-content>
    </div>
  </div>
  <div class="error" *ngIf="showError">{{ errorMessage }}</div>
</div>
